import React from "react";
import { LoadingOutlined } from "@ant-design/icons";

export const MONTHS = [
  { key: "jan", label: "Jan" },
  { key: "feb", label: "Feb" },
  { key: "mar", label: "Mar" },
  { key: "apr", label: "Apr" },
  { key: "may", label: "May" },
  { key: "jun", label: "Jun" },
  { key: "jul", label: "Jul" },
  { key: "aug", label: "Aug" },
  { key: "sep", label: "Sep" },
  { key: "oct", label: "Oct" },
  { key: "nov", label: "Nov" },
  { key: "dec", label: "Dec" },
];

export const buildDefault24HourMatrix = () => {
  return Array.from({ length: 24 }, (_, i) => {
    const hour = i + 1;
    const row = { hour };
    MONTHS.forEach((m) => {
      row[m.key] = false;
    });
    return row;
  });
};

export default function StepDischargeSchedule({
  loadingDischarge = false,
  savingDischarge = false,
  dischargeProfile = [],
  setDischargeProfile,
  onBack,
  onSubmit,
}) {
  const handleToggleCell = (hour, monthKey) => {
    setDischargeProfile((prev) =>
      prev.map((row) =>
        row.hour === hour ? { ...row, [monthKey]: !row[monthKey] } : row
      )
    );
  };

  const handleToggleRow = (hour, isChecked) => {
    setDischargeProfile((prev) =>
      prev.map((row) => {
        if (row.hour === hour) {
          const updated = { ...row };
          MONTHS.forEach((m) => {
            updated[m.key] = isChecked;
          });
          return updated;
        }
        return row;
      })
    );
  };

  const handleToggleColumn = (monthKey, isChecked) => {
    setDischargeProfile((prev) =>
      prev.map((row) => ({
        ...row,
        [monthKey]: isChecked,
      }))
    );
  };

  const handleToggleAllMatrix = (isChecked) => {
    setDischargeProfile((prev) =>
      prev.map((row) => {
        const updated = { ...row };
        MONTHS.forEach((m) => {
          updated[m.key] = isChecked;
        });
        return updated;
      })
    );
  };

  const isAllMatrixChecked =
    dischargeProfile.length > 0 &&
    dischargeProfile.every((row) => MONTHS.every((m) => row[m.key] === true));

  return (
    <div className="space-y-6 animate-fade-in">
      {loadingDischarge ? (
        <div className="text-center py-20 text-slate-400 text-xs">
          <LoadingOutlined className="text-xl mb-2 text-[#0052CC] animate-spin" />
          <div>Loading discharge profile configurations...</div>
        </div>
      ) : (
        <div
          className="overflow-auto border border-slate-100 rounded-xl bg-white shadow-sm"
          style={{ maxHeight: "600px" }}
        >
          <table className="bess-table">
            <thead>
              <tr>
                <th className="text-center w-16">
                  <div className="flex flex-col items-center gap-1.5">
                    <input
                      type="checkbox"
                      className="w-3.5 h-3.5 accent-[#0052CC] cursor-pointer"
                      checked={isAllMatrixChecked}
                      onChange={(e) => handleToggleAllMatrix(e.target.checked)}
                    />
                    <span className="text-[10px] uppercase font-bold text-slate-500">
                      Toggle
                    </span>
                  </div>
                </th>
                <th>Hour</th>
                {MONTHS.map((m) => (
                  <th key={m.key} className="text-center w-16">
                    <div className="flex flex-col items-center gap-1.5">
                      <input
                        type="checkbox"
                        className="w-3.5 h-3.5 accent-[#0052CC] cursor-pointer"
                        checked={
                          dischargeProfile.length > 0 &&
                          dischargeProfile.every((row) => row[m.key] === true)
                        }
                        onChange={(e) => handleToggleColumn(m.key, e.target.checked)}
                      />
                      <span className="text-[10px] uppercase font-bold text-slate-500">
                        {m.label}
                      </span>
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {dischargeProfile.map((row) => (
                <tr key={row.hour} className="hover:bg-slate-50/50">
                  <td className="text-center">
                    <input
                      type="checkbox"
                      className="w-3.5 h-3.5 accent-[#0052CC] cursor-pointer"
                      checked={MONTHS.every((m) => row[m.key] === true)}
                      onChange={(e) => handleToggleRow(row.hour, e.target.checked)}
                    />
                  </td>
                  <td className="font-bold">
                    Hour {row.hour.toString().padStart(2, "0")}:00
                  </td>
                  {MONTHS.map((m) => (
                    <td key={m.key} className="text-center">
                      <input
                        type="checkbox"
                        checked={row[m.key] || false}
                        onChange={() => handleToggleCell(row.hour, m.key)}
                        className="w-4 h-4 accent-[#0052CC] rounded cursor-pointer"
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="flex justify-between items-center pt-6 border-t border-slate-100 mt-8">
        <button
          type="button"
          onClick={onBack}
          className="bess-btn-secondary"
        >
          Back
        </button>
        <button
          type="button"
          onClick={onSubmit}
          disabled={savingDischarge}
          className="bess-btn-primary"
        >
          {savingDischarge ? <LoadingOutlined /> : "Save & Continue →"}
        </button>
      </div>
    </div>
  );
}
